module.exports = __webpack_public_path__ + "img/right1.3413e808.png";